module.exports = __webpack_public_path__ + "static/media/46.fb21ba85.jpg";